import React from "react";
import {VerifyRmaSerialNoMapType} from "../../../../types/support";
import EmptyTableRow from "../../../../pages/common/EmptyTableRow";
import moment from "moment/moment";
import {ModalInnerAlertType} from "../interface";
import {useModal} from "../../../../hooks";

interface PropsType {
    data: VerifyRmaSerialNoMapType
}

export default function VerifyRmaSerialNoInner({data, cancelCallback, modalDepth}: ModalInnerAlertType<PropsType>) {
    const {handleModal, resetModal} = useModal();

    const successList = data?.outgoingManagementVOList ?? []
    const failList = data?.failSerialCodeList ?? []

    const maxFailRow = Math.max(failList.filter((_, idx) => idx % 2 === 0).length, failList.filter((_, idx) => idx % 2 === 1).length)
    const leftFailList = Array.from({length: maxFailRow}, (_, i) => failList.filter((_, idx) => idx % 2 === 0)[i] ?? "")
    const rightFailList = Array.from({length: maxFailRow}, (_, i) => failList.filter((_, idx) => idx % 2 === 1)[i] ?? "")

    const onClose = () => {
        resetModal(modalDepth)
        cancelCallback && cancelCallback()
    }

    return <>
        <div className="modal_alert_primary mb-15px">
            <img src={process.env.PUBLIC_URL + "/assets/images/icon_img_ok.png"} alt=""/>
            검증 성공 Serial
        </div>
        <div className="table_top">
            <h6 className="table_stats">검증 성공 목록(<span>{successList.length}</span>건)</h6>
        </div>
        <div className="table_scroll">
            <table className="table table-bordered my_table table_modal m-0" style={{minWidth: "unset"}}>
                <thead>
                <tr>
                    <th>거래처 코드</th>
                    <th>출고업체명</th>
                    <th>규격</th>
                    <th>SN(start)</th>
                    <th>SN(end)</th>
                    <th>출고일</th>
                    <th>파일명</th>
                    <th>QTY</th>
                    <th>비고</th>
                </tr>
                </thead>
                <tbody>
                {successList.length !== 0
                    ? successList.map(el => <tr>
                        <td className="text-center">{el.accountCode}</td>
                        <td className="text-center">{el.outgoingAccountName}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.serialNoStart1}</td>
                        <td className="text-center">{el.serialNoEnd1}</td>
                        <td className="text-center">{moment(el.outgoingDate).isValid() ? moment(el.outgoingDate).format("YYYY-MM-DD") : ""}</td>
                        <td className="text-center">{el.fileName}</td>
                        <td className="text-center">{el.qty}</td>
                        <td>{el.remark}</td>
                    </tr>)
                    : <EmptyTableRow colSpan={9}/>
                }
                </tbody>
            </table>
        </div>

        <div className="modal_alert_danger mb-15px">
            <img src={process.env.PUBLIC_URL + "/assets/images/icon_img_failure.png"} alt=""/>
            검증 실패 Serial
        </div>
        <div className="table_top">
            <h6 className="table_stats">검증 실패 목록(<span>{failList.length}</span>건)</h6>
        </div>
        {failList.length !== 0
            ? <div className="row">
                <div className="col-6">
                    <table className="table table-bordered my_table table_modal m-0">
                        <thead>
                        <tr>
                            <th>Serial No</th>
                        </tr>
                        </thead>
                        <tbody>
                        {leftFailList.map(i => (
                            <tr>
                                <td className="text-center">{i}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="col-6">
                    <table className="table table-bordered my_table table_modal m-0">
                        <thead>
                        <tr>
                            <th>Serial No</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rightFailList.map(i => (
                            <tr>
                                <td className="text-center">{i}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            : <table className="table table-bordered my_table table_modal m-0">
                <thead>
                <tr>
                    <th>Serial No</th>
                </tr>
                </thead>
                <tbody>
                <EmptyTableRow/>
                </tbody>
            </table>
        }

        <div className="mt-3 d-flex align-items-center justify-content-end">
            <button
                type="button"
                className="btn btn-outline-secondary w-100px h-38px my-0"
                onClick={onClose}>
                <img src={process.env.PUBLIC_URL + "/assets/images/icon_cross_grey.png"} alt=""/>닫기
            </button>
        </div>
    </>
}